// Generato dalla pipeline o da npm run inject-secrets. Non committare.
export const secrets = {
	"recaptchaKey": "AIzaSyCL4_K70bI-K3qDHkMaR7p8xYblX6U_Mjc",
	"googleAPI": "AIzaSyCL4_K70bI-K3qDHkMaR7p8xYblX6U_Mjc",
	"clientId": "2JFVU0A4KXLYo3zJO1NMuKpTuI4Ryfya",
	"clientSecret": "MQQFhzVZCXUD87TwP21L3ALdJYcPGCCPSqQTjMrnwG5SwQY6w6xFa9hnidS9KkZb8MMUBJJC8U2UdpFqdUVjbXtzdNqUk9eDu72VF6YdKTq8Z8ULzmbcAvgEiNwzZq2x6RLxF7ewCqAMUcUBPEAXhJwqv7j6f3bxJZNZZmLpWn5b8MqVxwk6CNq0C6uVTrRJuwTEkY23Vpq5Atwyq0QataMwcYDTZCFJgJJ1DiBRdMmHX0tXE4gnSLiJEF70LXfG",
	"firebase_apiKey": "AIzaSyDazR7lqi8A_oJ0za1QFxFpDznDo2rhB5w",
	"firebase_appId": "1:280100852754:web:125dc594c384ffdade74cb",
	"firebase_messagingSenderId": "280100852754",
	"firebase_measurementId": "G-VSGE5F4WE5"
};
